/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { ICartItemInfo } from '../../../models/pro-sites';
import { FormattedMessage } from 'react-intl';

interface IQuantityProps {
    item: ICartItemInfo;
    maxQuantity: number;
    onUpdateItemQuantity: (itemId: string, quantity: number) => Promise<void>;
    setDisableProceedToCheckout: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Quantity = ({
    item,
    maxQuantity,
    onUpdateItemQuantity,
    setDisableProceedToCheckout,
}: IQuantityProps) => {
    const [quantity, setQuantity] = useState<number>(item.quantity);
    const [updatedQuantity, setUpdatedQuantity] = useState<boolean>(false);
    const [quantityHasFocus, setQuantityHasFocus] = useState<boolean>(false);
    const [updatingQuantity, setUpdatingQuantity] = useState<boolean>(false);

    const handleChangeQty = (e: any) => {
        const num = e.target.value as number;
        if (num !== item.quantity) {
            setDisableProceedToCheckout(true);
        } else {
            setDisableProceedToCheckout(false);
        }

        if (num && num > 0) {
            setQuantity(Math.round(num > maxQuantity ? maxQuantity : num));
        } else {
            setQuantity(0);
        }

        setUpdatedQuantity(false);
    };

    const updateQuantity = async () => {
        if (!quantity) {
            setQuantity(1);
            setUpdatingQuantity(true);
            await onUpdateItemQuantity(item.itemID, 1);
            setUpdatedQuantity(true);
            setUpdatingQuantity(false);
        } else {
            //for some reason item.quantity is coming in as string and have to do value check instead of type check.
            // eslint-disable-next-line eqeqeq
            if (item.quantity != quantity) {
                setUpdatingQuantity(true);
                await onUpdateItemQuantity(item.itemID, quantity);
                setUpdatedQuantity(true);
                setUpdatingQuantity(false);
            }
        }
    };

    const handleKeyPressQty = (e: any) => {
        if (e.key === 'Enter') {
            updateQuantity();
            setQuantityHasFocus(false);
        }
    };

    const handleUpdateQuantity = () => {
        updateQuantity();
    };

    return (
        <>
            {item.blockQuantityUpdate ? (
                <span id="cart-item-quantity">{item.quantity}</span>
            ) : (
                <div className="form-inline">
                    <div
                        className="form-group"
                        style={{ marginBottom: '10px' }}
                    >
                        <div className="input-group">
                            <input
                                id={item.selectedItemNumber}
                                type="number"
                                value={quantity && quantity > 0 ? quantity : ''}
                                name={'quantity-' + item.itemID}
                                className="form-control"
                                style={{ width: '60px' }}
                                onChange={handleChangeQty}
                                onKeyPress={handleKeyPressQty}
                                onFocus={() => {
                                    setQuantityHasFocus(true);
                                }}
                                onBlur={() => {
                                    setQuantityHasFocus(false);
                                    setTimeout(() => {
                                        handleUpdateQuantity();
                                    }, 100);
                                }}
                            />
                            <span
                                style={{ width: 'auto' }}
                                className="input-group-addon"
                            >
                                {updatingQuantity ? (
                                    <img
                                        alt="updating"
                                        style={{ verticalAlign: 'top' }}
                                        src="/images/icons/loading.gif"
                                    />
                                ) : updatedQuantity && !quantityHasFocus ? (
                                    <span className="glyphicon glyphicon-ok text-success"></span>
                                ) : (
                                    <a
                                        onClick={handleUpdateQuantity}
                                        id="cart-update-btn"
                                    >
                                        <FormattedMessage id="Update" />
                                    </a>
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Quantity;
